import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { api } from '@/lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];
        if (!sessionId) {
          navigate('/', { replace: true });
          return;
        }
        await api.get(`/auth/session?session_id=${sessionId}`);
        await refreshUser();
        // Clear the hash and navigate
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 animate-fade-in">
        <div className="w-16 h-16 rounded-full border-4 border-[#2EC4B6] border-t-transparent animate-spin" />
        <p className="text-[#5C6B7F] font-bold text-lg">Signing you in...</p>
      </div>
    </div>
  );
}
